import $ from "jquery";
import Sortable from "sortablejs";

$(function () {
  $(".js-editable-list").each((index, list) => {
    var sortable = Sortable.create(list, {
      draggable: ".js-editable-list-item",
      handle: ".js-drag-handle",
      onUpdate: function (evt) {
        $(list)
          .find(".js-editable-list-item")
          .each((index, item) => {
            $(item)
              .find(".js-list-item-position")
              .val(index + 1);
          });
      },
    });
  });
});

// Section dropdown populate
$(function () {
  let list = $("#js-groups");
  if (list.length > 0) {
    $.getJSON("/Admin/GetSections", function (data) {
      $.each(data, function (_index, value) {
        list.append($("<option>", { value: value }));
      });
    });
  }
});

// Prevent fast consecutive clicks triggering repeated emails...
$(function () {
  $("a.button.js-email-trigger").on("click tap", function (event) {
    var d = $(event.target).attr("disabled");
    if (d) {
      event.preventDefault();
      return false;
    } else {
      $(event.target).attr("disabled", true);
      return true;
    }
  });
});

// Inline editing of Quotes and Variations
$(function () {
  const addItem = function (event) {
    event.preventDefault();

    var siblings = $(event.target).siblings(".js-editable-list-block");
    var parents = $(event.target).parents(".js-editable-list-block");
    var block = $(siblings[0] || parents[0]);
    var controller = block.data("controller");
    var action = block.data("action");
    var parentId = block.data("parent");
    var list = block.find(".js-editable-list");

    // optional prefill
    var descriptionPrefill = $(block).find("input.js-el-prefill-description");
    var groupPrefill = $(block).find("input.js-el-prefill-group");
    var valuePrefill = $(block).find("input.js-el-prefill-value");
    var description = (descriptionPrefill.val() || "").trim();
    var group = (groupPrefill.val() || "").trim();
    var value = (valuePrefill.val() || "0").trim();

    // zero-based list index for MVC Forms.Like[n].This
    var index = block.find(".js-editable-list-item").length;

    // call the back end for a rendered blob to stick on the list
    fetch(
      `/${controller}/${action}?parentId=${parentId}&index=${index}&description=${description}&group=${group}&value=${value}`
    )
      .then((resp) => {
        return resp.text();
      })
      .then((text) => {
        $(text).appendTo(list);
      })
      .then(() => {
        // length must now be > 1
        $(list).removeClass("hidden");
        $(block).find(".js-editable-list-header").removeClass("hidden");
        $(block).find(".js-editable-list-invitation").addClass("hidden");
      })
      .then(() => {
        // clear the inputs
        descriptionPrefill.val("");
        groupPrefill.val("");
        valuePrefill.val("");
      })
      .catch((err) => {
        console.warn(err);
      });
  };

  const deleteItem = function (event) {
    event.preventDefault();

    if (!confirm("Really delete item?")) {
      return;
    }

    var item = $(event.target).parents(".js-editable-list-item");
    var checkbox = $(item).find('[type="checkbox"]');
    checkbox.removeProp("checked");
    checkbox.removeAttr("checked");
    $(item).find("input").prop("required", null); // remove 'required' from hidden so the form submits
    $(item).addClass("hidden");

    var block = $(item).parents(".js-editable-list-block");
    var list = $(block).find(".js-editable-list-item:visible");
    if (list.length === 0) {
      console.log("hiding header, showing invitation");
      $(block).find(".js-editable-list-header").addClass("hidden");
      $(block).find(".js-editable-list-invitation").removeClass("hidden");
    } else {
      console.log("showing header, hiding invitation");
      $(block).find(".js-editable-list-header").removeClass("hidden");
      $(block).find(".js-editable-list-invitation").addClass("hidden");
    }
  };

  const toggleItem = function (event) {
    event.preventDefault();

    var parent = $(event.target).parents(".js-editable-list-item");
    var checkbox = $(parent).find("input.js-cancellable-list-item-checkbox");
    var oldValue = checkbox.val();

    var wasCancelled = oldValue === "True";
    var target = $(event.target);

    checkbox.val(wasCancelled ? "False" : "True");
    target.html(wasCancelled ? "Cancel" : "Reinstate");

    if (wasCancelled) {
      target.removeClass("button-neutral");
      target.addClass("button-remove");
    } else {
      target.addClass("button-neutral");
      target.removeClass("button-remove");
    }

    $(parent).toggleClass("list-item-cancelled");
  };

  $(document).on("click tap", ".js-editable-list-add", addItem);
  $(document).on("click tap", ".js-remove-list-item", deleteItem);
  $(document).on("click tap", ".js-toggle-list-item", toggleItem);
});

// Validation of approval deadline dates, which can't be in the past
$(function () {
  const validateDeadlineDate = function (container) {
    var value = $(container).find("input.js-deadline-date-input").val();

    if (value) {
      try {
        var asDate = new Date(value);
        var asDay = new Date(
          asDate.getFullYear(),
          asDate.getMonth(),
          asDate.getDate()
        );
        var now = new Date();
        var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

        if (asDay < today) {
          $(container)
            .find(".js-deadline-date-validation")
            .removeClass("hidden");
          $(container)
            .find(".js-deadline-date-validation")
            .addClass("inline-block");
          return false; // prevents submission
        }
      } catch (err) {
        console.warn(err);
      }
    }

    //future date or empty field, hide validation, return true to allow submission
    $(container).find(".js-deadline-date-validation").addClass("hidden");
    $(container)
      .find(".js-deadline-date-validation")
      .removeClass("inline-block");
    return true;
  };

  $("input.js-deadline-date-input").on("change blur input", function (e) {
    var form = $(e.target).parents("form.js-deadline-date");
    validateDeadlineDate(form); // return nothing to allow the change to happen
  });

  $("form.js-deadline-date").on("submit", function (e) {
    var form = $(e.target);
    return validateDeadlineDate(form); // return false => stops submission
  });

  // validate on loadasyn
  validateDeadlineDate($("form.js-deadline-date"));
});

// Override send-to-client action
$(function () {
  $(".js-send-to-client-action").on("click tap", function (e) {
    var form = $("form.js-send-to-client-form");
    if (form && form.length === 1) {
      e.preventDefault();
      form.trigger("submit");
    }
  });
  // Show or hide the cancellable items on a variation
  $(function () {
    const showHideCancelItems = function (event) {
      event.preventDefault();
      var list = $(event.target).parent().find(".cancel-item-list");
      list.toggle();
      if ($(event.target).text() == "Show Cancellable Items") {
        $(event.target).text("Hide Cancellable Items");
      } else {
        $(event.target).text("Show Cancellable Items");
      }
    };
    $(document).on(
      "click tap",
      ".js-showhide-cancel-items",
      showHideCancelItems
    );
  });
});
